// views/auth/login.js  (IT)
export const login_i18n = {
  panelKicker: "WACHECKIN · 2026",
  panelCta: "Scopri WACheckin",
  partnersLabel: "Collegato con",
  // Le schede della scena del pannello.
  escena: {
    reservas: "Prenotazioni",
    mensajes: "Messaggi automatici",
    llaves: "Chiavi digitali",
    checkin: "Check-in online",
    cobros: "Pagamenti automatici",
    autoridades: "Autorità e conformità",
  },

  // Passo 2: il codice che arriva via email.
  verify: {
    title: "Controlla la tua email",
    titleWhatsapp: "Controlla il tuo WhatsApp",
    sending: "Invio in corso…",
    destinoWhatsapp: "Arriverà al",
    destinoCorreo: "Arriverà a",
    intro: "Ti abbiamo inviato un codice di {largo} cifre a",
    submit: "Accedi",
    submitting: "Verifica in corso...",
    back: "Usa un altro account",
    resendAsk: "Non ti arriva?",
    resend: "Invia di nuovo",
    resendWait: "Invia di nuovo tra {s} s",
    resendDone: "Ti abbiamo inviato un nuovo codice.",
    expires: "Il codice scade tra {tiempo}",
    expired: "Il codice è scaduto. Richiedine uno nuovo.",
    digitAria: "Cifra {n} di {total}",
    otroMetodo: "Non ti arriva l'email?",
    porWhatsapp: "Ricevilo su WhatsApp",
    preferesCorreo: "Preferisci l'email?",
    porCorreo: "Ricevilo via email",
    introWhatsapp: "Ti abbiamo inviato un codice di {largo} cifre su WhatsApp al",
    enviadoWhatsapp: "Ti abbiamo inviato il codice su WhatsApp.",
  },
  langLabel: "Lingua",
  panelTitle: "Tutti i tuoi alloggi automatizzati con l'IA",
  panelDesc:
    "Check-in, messaggi, chiavi, incassi e autorità. Un unico pannello per tutto.",

  bannerAlt: "sfondo di accesso",
  brandAlt: "WA Checkin",
  footerLogoAlt: "WA Checkin",
  togglePasswordAria: "mostra o nascondi la password",

  title: "Bentornato!",
  infoTitle: "Se hai già un account, entra con la tua email.",
  infoDesc: "Se non hai ancora un account, puoi registrarti in fondo.",

  emailLabel: "Email",
  emailPlaceholder: "Inserisci la tua email",

  passwordLabel: "Password",
  passwordPlaceholder: "Inserisci la tua password",

  forgot: "Hai dimenticato la password?",

  submit: "Accedi",
  submitting: "Accesso in corso...",

  noAccount: "Non hai un account?",
  signup: "Registrati",

  terms: "Regolamento",
  privacy: "Informativa sulla privacy",
  copyright: "© 2024–{anio} WA Checkin. Tutti i diritti riservati.",

  resetSuccess: "Ti abbiamo inviato un'email per recuperare la password.",

  errors: {
    default: "Errore durante l'accesso.",
    network: "Errore di connessione. Riprova.",
  },

  resetPassword: {
    title: "Recupera password",
    infoTitle: "Ti invieremo un link via email",
    infoDesc:
      "Inserisci la tua email e riceverai le istruzioni per reimpostare la password.",
    labels: { email: "Indirizzo email" },
    placeholders: { email: "nome@email.com" },
    hints: { email: "Usa l'email con cui ti sei registrato." },
    buttons: { send: "Invia", sending: "Invio..." },
    successTitle: "Fatto!",
    successDesc: "Controlla la posta in arrivo (e lo spam).",
    aria: { close: "chiudi" },
    toasts: {
      emailRequired: "Inserisci la tua email.",
      sent: "Abbiamo inviato l'email con le istruzioni.",
      userNotFound: "Utente non registrato.",
      networkError: "Errore di connessione. Riprova.",
    },
  },
  common: { ok: "Ho capito", cancel: "Chiudi" },
};
